export enum WalletTransferTab {
  ACCOUNT = 'account',
  SHARELAND = 'shareland',
  STABLE = 'stable',
  NATIVE = 'native',
}
